import { ModalManager } from './ModalManager'

export default ModalManager
